<template>
  <b-modal ref="modalEditionLieuConsommation" size="xxl" title="Paramétrage du lieu de consommation" no-close-on-backdrop scrollable
    :header-bg-variant="lectureSeule ? 'secondary' : 'primary'">
    <!-- @show="initialiserModale()"> -->
    <!-- ok-title="Enregistrer" :ok-disabled="false"
    cancel-title="Annuler"
    @ok="enregistrerLieu"> -->

    <template slot="default">
      <EditionLieuConsommation :lieuConsommationId="lieuConsommationId" :structures="structures" :barquettes="barquettes" />
    </template>
    <template slot="modal-footer">
      <div class="flex-center-space-between w-100">
        <div>
          <button type="button" class="btn btn-primary mr-2" :disabled="!lieuValide || lectureSeule" @click="addTypeConvive(lieuEnCours)">Ajouter un type de convive</button>
          <button type="button" class="btn btn-primary mr-2" :disabled="!lieuValide || lectureSeule" @click="afficherEffectifsDetailles()">Effectifs détaillés</button>
          <BoutonGestionBarquettes class="mr-4" :disabled="!lieuValide || lectureSeule" :dropLeft="true" />
        </div>
        <div>
          <button type="button" class="btn btn-secondary mr-2" @click="annulerEdition">Annuler</button>
          <button type="button" class="btn btn-primary" :disabled="!lieuValide" @click="enregistrerLieu">Enregistrer</button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import EditionLieuConsommation from "@/components/Menus/EditionLieuConsommation"
import BoutonGestionBarquettes from "@/components/Divers/BoutonGestionBarquettes"
import { connecteData } from "@/mixins/connecteData"
import { chargerToutesLesStructures } from '@/api/gpao/menus'
import { obtenirBarquettes } from '@/api/gpao/production'
import { mapGetters } from "vuex"
import _ from 'lodash'

export default {
  name: "ModalEditionLieuConsommation",
  props: {
    "lieuConsommationId": Number
  },
  components: { EditionLieuConsommation, BoutonGestionBarquettes },
  mixins: [ connecteData ],
  data() {
    return {
      lieuEnCours: null,
      structures: [],
      barquettes: []
    }
  },
  computed: {
    ...mapGetters("definitions", ["convivesTypesNonNeutre", "regimes", "textures", "services"]),
    optionsConviveType() { return this.convivesTypesNonNeutre },
    optionsRegimes() { return this.regimes },
    optionsTextures() { return this.textures },
    optionsServices() { return this.services },
    lectureSeule() { return !this.lieuEnCours?.actif ?? true },
    effectifsEnCours() {
      return this.lieuEnCours?.typesConvives?.map(tc => tc.syntheseEffectifs)?.filter(x => x.effectif !== -1) || []
    },
    // typesConvivesEnCours() {
    //   let tc = [...new Set(this.effectifsEnCours.map(e => e.typeConviveId))]
    //   debugger
    //   return [...new Set(this.effectifsEnCours.map(e => e.typeConviveId))]
    // },
    nomValide() {
      return this.lieuEnCours?.libelle?.length > 3
    },
    lieuValide() {
      // Vérification du nom du lieu de consommation
      if (!this.nomValide)
        return false  // Nom du lieu invalide

      // Vérification de la présence d'au moins un type de convive
      if (!this.lieuEnCours.typesConvives?.length)
        return false

      // Vérification de la présence d'au moins un effectif pour chaque type de convive
      if (this.lieuEnCours.typesConvives.some(tc => !tc.syntheseEffectifs?.filter(e => e.effectifs)?.length))
        return false

      // Vérification de la saisie correcte de chaque effectif
      if (this.lieuEnCours.typesConvives.some(tc => tc.syntheseEffectifs.some(e => !e.structureMenuId || !e.typeRegimeId || !e.typeTextureId)))
        return false

      // Vérification de la présence de doublons de types de convives
      if (this.lieuEnCours.typesConvives.some(tc => this.estDoublon(tc, this.lieuEnCours.typesConvives)))
        return false

      // Vérification de la présence de doublons d'effectifs au sein de chaque type de convive
      if (this.lieuEnCours.typesConvives.some(tc => tc.syntheseEffectifs.some(e => this.estDoublon(e, tc.syntheseEffectifs))))
        return false

      return true
    }
  },
  methods: {
    // async initialiserModale() {
    //   if (this.action === "ajouter") {
    //     debugger
    //     this.lieuEnCours = this.creerNouveauLieu()
    //     //this.addTypeConvive()
    //   } else {
    //     let response = await getLieuConsommation(this.lieuConsommationId)
    //     this.lieuEnCours = response.data
    //   }

    //   this.lieuEnCours.typesConvives.forEach(tc => {
    //     tc.typeConviveChoisi = { id: tc.typeConviveId, nom: tc.nomTypeConvive }
    //     tc.syntheseEffectifs = this.detailVersRecap(tc.effectifs, true)
    //   })
    //   this.checkLieu()
    // },
    creerNouveauLieu() {
      let nouveauLieu = {
        etablissementId: this.etabCourantId,
        actif: true,
        libelle: 'Nouveau lieu',
        typeLiaisonId: null,
        adresse1: '',
        adresse2: '',
        adresse3: '',
        codePostal: '',
        ville: '',
        joursConsommation: [],
        // effectifsParDefaut: [],
        // typesConvives: []
        // typesConvives: [{
        //   typeConviveId: null,
        //   effectifs: [{
        //     typeConviveId: null,
        //     structureMenuId: null,
        //     typeServiceId: null,
        //     typeRegimeId: null,
        //     typeTextureId: null,
        //     effectifs: 0,
        //     aPlatTemoin: false,
        //     jour: null
        //   }]
        // }]
        //ordreLivraison: this.lieux.length ? Math.max.apply(Math, this.lieux.map(l => l.ordreLivraison)) + 1 : 1,
        //barquettes: _.cloneDeep(this.listeBarquettes) //Toutes les barquettes sélectionnées par défaut
      }
      this.addTypeConvive(nouveauLieu)
      return nouveauLieu
    },
    show() {
      this.$refs.modalEditionLieuConsommation.show()
    },
    // show(lieu, listeBarquettes) {
    //   if (!lieu)
    //     return
      
    //   //this.lieuEnCours = {...lieu}
    //   this.lieuEnCours = _.cloneDeep(lieu)
    //   this.listeBarquettes = listeBarquettes || []

    //   this.checkLieu()
    //   this.$refs.modalEditionLieuConsommation.show()
    // },
    hide() {
      this.$refs.modalEditionLieuConsommation.hide()
    },
    selectionnerTypeConvive(typeConviveAModifier, typeConviveChoisi) {
      typeConviveAModifier.typeConviveId = typeConviveChoisi.id
      typeConviveAModifier.nomTypeConvive = typeConviveChoisi.nom

      // // Mise à jour du type de convive sur la synthèse des effectifs
      // typeConviveAModifier.syntheseEffectifs.forEach(e => {
      //   e.typeConviveId = typeConviveChoisi.id
      //   e.nomTypeConvive = typeConviveChoisi.nom
      // })

      // // Mise à jour du type de convive sur les effectifs
      // typeConviveAModifier.effectifs.forEach(e => {
      //   e.typeConviveId = typeConviveChoisi.id
      //   e.nomTypeConvive = typeConviveChoisi.nom
      // })
    },
    selectionnerStructureMenu(structureMenuAModifier, structureMenuChoisie) {
      structureMenuAModifier.structureMenuId = structureMenuChoisie.id
      structureMenuAModifier.nomStructureMenu = structureMenuChoisie.nom
    },
    selectionnerTypesServices(typesServicesAModifier, typesServicesChoisis) {
      typesServicesAModifier.typeServiceId = typesServicesChoisis.id
      typesServicesAModifier.nomTypeService = typesServicesChoisis.nom
    },
    selectionnerTypeRegime(typeRegimeAModifier, typeRegimeChoisi) {
      typeRegimeAModifier.typeRegimeId = typeRegimeChoisi.id
      typeRegimeAModifier.nomTypeRegime = typeRegimeChoisi.nom
    },
    selectionnerTypeTexture(typeTextureAModifier, typeTextureChoisi) {
      typeTextureAModifier.typeTextureId = typeTextureChoisi.id
      typeTextureAModifier.nomTypeTexture = typeTextureChoisi.nom
    },
    // ModifierSyntheseEffectif(ancienEffectif, nouvelEffectif) {
    //   // Recherche des effectifs à modifier
    //   let anciensEffectifs = 
    // },
    creerStructureMenu() {
      this.$refs.editionStructureMenu.afficherModal()
    },
    ouvrirStructureMenu(structureMenuId) {
      this.$refs.editionStructureMenu.afficherModal(structureMenuId)
    },
    supprimerEffectif(effectif) {
      effectif.effectif = -1
    },
    afficherEffectifsDetailles() {

    },
    effectifsTypeConvive(typeConviveId) {
      //let e = this.effectifsEnCours
      //debugger
      return this.effectifsEnCours.filter(e => e.typeConviveId === typeConviveId)
    },
    addTypeConvive(lieu) {
      if (!lieu)
        lieu = this.lieuEnCours

      if (!lieu.typesConvives)
        lieu.typesConvives = []

      let nouveauTypeConvive = { typeConviveId: null, nomTypeConvive: "", effectifs: [], syntheseEffectifs: [] }
      this.addEffectif(nouveauTypeConvive)

      lieu.typesConvives.push(nouveauTypeConvive)
      //this.lieuEnCours.typesConvives.push({ structureMenuId: null, typeServiceId: null, typeRegimeId: null, typeTextureId: null, effectifs: 0, barquettes: [] })
    },
    addEffectif(typeConvive) {
      if (!typeConvive.syntheseEffectifs)
        typeConvive.syntheseEffectifs = []
      typeConvive.syntheseEffectifs.push({ structureMenuId: null, typeServiceId: null, typeRegimeId: null, typeTextureId: null, effectifs: 0, barquettes: this.barquettes })
    },
    checkLieu() {
      if (!this.lieuEnCours.joursConsommation) {
        // Initialisation de la liste des jours
        this.lieuEnCours.joursConsommation = []
      }
      if (!this.lieuEnCours.typesConvives?.length) {
        // Initialisation de la liste des effectifs
        this.addTypeConvive()
      } else {
        // Mise en forme correcte des régimes et textures avec de ne pas avoir de valeur vide dans les configuration
        // => permet de corriger les anciennes configurations créées avant la mise en place des contrôles de saisie
        let regimeNormalId = [...this.regimes].sort((t1, t2) => t1.ordre - t2.ordre).first()?.value
        let textureNormaleId = [...this.textures].sort((t1, t2) => t1.ordre - t2.ordre).first()?.value
        if (!regimeNormalId && !textureNormaleId) {
          return
        }
        this.lieuEnCours.typesConvives.map(tc => tc.syntheseEffectifs).forEach(e => {
          if (!e.typeRegimeId && regimeNormalId) {
            e.typeRegimeId = regimeNormalId
          }
          if (!e.typeTextureId && textureNormaleId) {
            e.typeTextureId = textureNormaleId
          }
        })
      }
    },
    enregistrerLieu() {
      this.$emit("enregistrer-lieu", this.lieuEnCours)
    },
    annulerEdition() {
      this.$emit("annuler-edition")
    },
    enregistrerBarquettesLieu(dataBarquettes) {
      
      this.lieuEnCours.barquettes = []
      dataBarquettes.forEach(b => {
        this.lieuEnCours.barquettes.push(this.barquettes.filter(x => x.id === b.Id).first())
      })

      /*var data = this.lieuEnCours.donneesSupplementaires && JSON.parse(this.lieuEnCours.donneesSupplementaires.replaceAll("'", "\"")) || {}
      data.Barquettage = dataBarquettes
      this.lieuEnCours.donneesSupplementaires = JSON.stringify(data).replaceAll("\"", "'")*/

    },
    enregistrerBarquettesEffectif(effectif, dataBarquettes) {
      
      effectif.barquettes = []
      dataBarquettes.forEach(b => {
        effectif.barquettes.push(this.barquettes.filter(x => x.id === b.Id).first())
      })

      /*var data = effectif.donneesSupplementaires && JSON.parse(effectif.donneesSupplementaires.replaceAll("'", "\"")) || {}
      data.Barquettage = dataBarquettes
      effectif.donneesSupplementaires = JSON.stringify(data).replaceAll("\"", "'")*/
    },
    jourChanged(jour, ouvert) {
      if (ouvert.target.checked) {
        this.lieuEnCours.joursConsommation.push(jour)
      } else {
        _.remove(this.lieuEnCours.joursConsommation, e => e === jour)
      }
    },
    afficherTexteAEffectif(typeConvive) {
      //debugger
      let nbEffectifs = 0
      if (typeConvive?.syntheseEffectifs?.length) {
        nbEffectifs = typeConvive.syntheseEffectifs.map(e => e.effectifs).reduce((a,c) => a + c, 0)
      }
      let capaciteAccueil = "Capacité d'accueil : " + nbEffectifs

      if (!typeConvive?.nomTypeConvive)
        return capaciteAccueil

      // if (!effectif || (effectif && !effectif.structureMenuId))
      //   return capaciteAccueil
      
      let informations = [
        typeConvive?.nomTypeConvive,
        capaciteAccueil
      ]

      return informations.filter(i => i).join(" - ")
    },
    estDoublon(element, liste) {
      let doublons = []
      if (element.structureMenuId) {
        // Nous sommes sur un effectif car ce sont les effectifs qui portent les structures de menus
        doublons = liste.filter(e => e.structureMenuId == element.structureMenuId && e.typeServiceId == element.typeServiceId
          && e.typeRegimeId == element.typeRegimeId && e.typeTextureId == element.typeTextureId) || []
      } else {
        // Nous sommes sur un type de convive dans le cas contraire
        doublons = liste.filter(e => e.typeConviveId == element.typeConviveId) || []
      }
      return doublons.length > 1
    },
    async chargerBarquettes() {
      // Chargement des barquettes possibles
      let ret = await obtenirBarquettes(this.etabCourantId)
      this.barquettes = ret.data || []
    },
    async chargerStructuresMenus() {
      // Chargement des structures de menus
      let ret = await chargerToutesLesStructures(this.etabCourantId)
      this.structures = ret.data || []
    }
  },
  mounted() {
    // Les structures et les barquettes sont des données qui ne sont pas vouées à être modifiées dans le cadre de cette fonctionnalité
    // Elles sont donc chargées ici et non dans le composant d'édition du lieu de consommation afin de les charger uniquement à l'ouverture de la page et de ne pas les recharger à chaque ouverture de modale
    this.chargerStructuresMenus()
    this.chargerBarquettes()
  }
}

</script>
